<script>
  import DialogBase from "../../../dialog/DialogBase.svelte";

  export let dialog
  export let onClose

  function onClickDialog(event) {
    if (event.target === dialog) {
      onClose()
    }
  }
</script>

<DialogBase bind:dialog={dialog} onClick={onClickDialog}>
  <slot />
</DialogBase>
